import configJson from "./config.json";

export default configJson
